
















import { computed, defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { useApi, useConfig, useContent } from '~/composables';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getProfessioniParentCategory, getTopicsParentCategory } from '~/utils/solepro/products';
import { getProductFilterByCategoryCommand } from '~/modules/catalog/category/components/filters/command/getProductFilterByCategoryCommand';
import { isFilterEnabled, isFilterEnabledInCategory } from '~/modules/catalog/category/config/FiltersConfig';
import axios from 'axios';
import { getAxiosConfigs } from '~/utils/solepro/functions';

export default defineComponent({
  name: 'CategoryLinks',
  props: {
    filterQP: { type: Object, required: true },
    activeCategoryUrlPath: { type: String, required: true },
    categoryUid: { type: String, required: true },
    relatedFilterCode: { type: String, required: true },
    urlKeys: { type: Object, required: true }
  },
  setup(props, { emit }) {
    const { config: storeConfig } = useConfig();
    const { loadBlocks } = useContent();
    const { query } = useApi();
    const categoryStore = useCategoryStore();
    const { app } = useContext()
    // 1. Stato locale con nomi univoci per evitare conflitti "readonly"
    const listOptions = ref([]);
    const mapKeys = props.urlKeys

    // 2. Computed per la visibilità
    const hasDataToShow = computed(() => listOptions.value.length > 0);

    // 3. Funzione per la generazione sicura dei link
    const formatFinalLink = (option: any) => {
      const store = storeConfig.value?.store_code || '';
      const categoryPath = props.activeCategoryUrlPath || '';
      const specificKey = mapKeys[option.value];
      return specificKey ? `/${store}/${categoryPath}/${specificKey}` : '#';
    };

    // --- FUNZIONI DI UTILITÀ INTERNE ---

    const getUrlKeysInternal = (cats: any[]) => (cats || []).reduce((acc, el) => {
      if (el?.url_path) {
        const parts = el.url_path.split('/');
        const key = parts.length > 1 ? parts[1] : parts[0];
        if (key && el.related_filter_value) {
          acc[el.related_filter_value] = `${key}${el.url_suffix || ''}`;
        }
      }
      return acc;
    }, {});

    const getFiltersInternal = (fetched: any) => {
      if (!fetched) return [];
      return fetched
        .filter((f: any) => isFilterEnabled(f.attribute_code))
        .filter((f: any) => isFilterEnabledInCategory(f.enabled_categories, props.categoryUid))
        .filter((f: any) => f.attribute_code !== props.relatedFilterCode)
        .sort((a: any, b: any) => (a.position ?? Infinity) - (b.position ?? Infinity));
    };

    // --- LOGICA DI FETCH SSR ---

    useFetch(async () => {
      const BASE = `solepro_custom_plp_`;

      try {
        // Recupero e pulizia categorie dallo store
        /*const raw = categoryStore.rawCategories?.items[0]?.children || [];
        const cleanCats = JSON.parse(JSON.stringify(raw));

        const profs = getProfessioniParentCategory(cleanCats)?.children;
        const topics = getTopicsParentCategory(cleanCats)?.children;

        // Popoliamo la mappa locale
        mapKeys.value = { ...getUrlKeysInternal(profs), ...getUrlKeysInternal(topics) };*/
        if (!props.activeCategoryUrlPath) return;

        const safePath = props.activeCategoryUrlPath.replace('prodotti/', '');

        // Generazione identificatori per i blocchi CMS
        const ids = Object.values(mapKeys)
          .filter(uk => typeof uk === 'string')
          .map(uk => `${BASE}${safePath}_${String(uk).replace('.html', '')}`);

        // Controllo disponibilità blocchi tramite API
        const { data: available } = await axios.post('/sole-api/category/getAvailableCMSBlocks', {
          identifierPattern: `${BASE}%`
        }, { ...getAxiosConfigs(app, storeConfig.value.store_code) });

        const safeAvailable = Array.isArray(available) ? available : [];
        const validIds = ids.filter(id => safeAvailable.includes(id));
        let allowedBlocksIdentifiers = [];
        let blockTitleMap = {};

        if (validIds.length > 0) {
          const blocks = await loadBlocks({ identifiers: validIds });
          allowedBlocksIdentifiers = blocks?.filter((b: any) => b?.identifier).map((b: any) => b.identifier) || [];
          blockTitleMap = Object.fromEntries((blocks || [])
              .filter((block) => block?.identifier)
              .map((block: any) => [block.identifier, block.title])
          );
        }

        // Recupero opzioni dai filtri prodotto
        const res = await getProductFilterByCategoryCommand.execute({ ...props.filterQP }, query);
        const filtered = getFiltersInternal(res);

        const combinedOptions = [
          ...(filtered.find((f: any) => f.attribute_code === 'tematiche')?.options || []),
          ...(filtered.find((f: any) => f.attribute_code === 'professioni')?.options || [])
        ];

        // Filtriamo le opzioni solo se esiste un blocco CMS corrispondente
        const finalResults = combinedOptions.map(el => {
            const k = mapKeys[el.value];
            if (!k) return false;
            const targetIdentifier = `${BASE}${safePath}_${String(k).replace('.html', '')}`;
            if (!blockTitleMap[targetIdentifier]) return null;

            return {
              ...el,
              blockTitle: blockTitleMap[targetIdentifier]
            };
          })
          .filter(Boolean);
        // Assegnazione finale "pulita" (Deep Copy) per evitare crash di serializzazione
        listOptions.value = JSON.parse(JSON.stringify(finalResults));

      } catch (e) {
        console.error("Errore CategoryLinks durante useFetch:", e);
      }
    });

    return {
      listOptions,
      hasDataToShow,
      formatFinalLink
    };
  }
});
